import { render } from "./Main.vue?vue&type=template&id=03c3593e"
const script = {}
script.render = render

export default script